

import { routes } from "routes";
import * as THREE from "three";
// import { ActionTypes, CornerProps, DimensionsTypes, materialType } from "types/three";
import { hexToRGB } from "utils/HexToRGB";
import { isValidJSON } from "utils/isValidJSON";
// import { ObjectType } from "types";






interface GeometryProps extends  DimensionsTypes , CornerProps ,ActionTypes {
    type?:GeometryTypes,
    parameters?:string,
    radiusTop?: number, 
    radiusBottom?:number ,
    material?:MaterialType
}





/**
 *  return  a geometry object and helper object   
 */ 


export const createGeometryForLevel = (type: string, params: any, div: number): THREE.BufferGeometry => {
    // const div = level === 0 ? 1 : level === 1 ? 2 : 8;
    if(div<1){
        div=1
    }

     if(params&&isValidJSON(params)){
        params=JSON.parse(params)
    }

   
    
    switch (type) {
        case "box":
            return new THREE.BoxGeometry(
                params?.width || 1, params?.height || 1, params?.depth || 1,
                Math.max(1, Math.floor((params?.widthSegments || 1) / div)),
                Math.max(1, Math.floor((params?.heightSegments || 1) / div)),
                Math.max(1, Math.floor((params?.depthSegments || 1) / div))
            );

        case "cone":
            return new THREE.ConeGeometry(
                params?.radius || 1, params?.height || 1,
                Math.max(4, Math.floor((params?.radialSegments || 32) / div)) // الحد الأدنى 4 أضلاع
            );

        case "cylinder":
            return new THREE.CylinderGeometry(
                params?.radiusTop ?? 0.5, params?.radiusBottom ?? 0.5, params?.height || 1,
                Math.max(6, Math.floor((params?.radialSegments || 32) / div)), // الحد الأدنى للأسطوانة البعيدة 6 أضلاع
                Math.max(1, Math.floor((params?.heightSegments || 5) / div)),
                params?.openEnded || false, params?.thetaStart || 0, params?.thetaLength || 6.29
            );

        case "sphere":
            return new THREE.SphereGeometry(
                params?.radius || 0.5,
                Math.max(3, Math.floor((params?.widthSegments || 32) / div)),
                Math.max(3, Math.floor((params?.heightSegments || 16) / div)),
                params?.phiStart || 0, params?.phiLength || 6.29,
                params?.thetaStart || 0, params?.thetaLength || 3.15
            );

        case "plane":
            return new THREE.PlaneGeometry(
                params?.width || 1, params?.height || 1,
                Math.max(1, Math.floor((params?.widthSegments || 1) / div)),
                Math.max(1, Math.floor((params?.heightSegments || 1) / div))
            );

        case "torus":


            return new THREE.TorusGeometry(
                params?.radius || 0.25, params?.tube || 0.12,
                Math.max(3, Math.floor((params?.radialSegments || 12) / div)),
                Math.max(3, Math.floor((params?.tubularSegments || 32) / div)),
                params?.arc || 6.29
            );

        case "torusknot":
            return new THREE.TorusKnotGeometry(
                params?.radius || 1, params?.tube || 0.4,
                Math.max(8, Math.floor((params?.tubularSegments || 64) / div)),
                Math.max(3, Math.floor((params?.radialSegments || 8) / div)),
                params?.p || 2, params?.q || 3
            );

        case "circle":
            return new THREE.CircleGeometry(
                params?.radius || 1,
                Math.max(4, Math.floor((params?.segments || 32) / div)),
                params?.thetaStart || 0, params?.thetaLength || 6.29
            );

        case "ring":
            return new THREE.RingGeometry(
                params?.innerRadius || 0.5, params?.outerRadius || 1,
                Math.max(4, Math.floor((params?.thetaSegments || 32) / div)),
                Math.max(1, Math.floor((params?.phiSegments || 8) / div))
            );

        case "icosahedron":
            return new THREE.IcosahedronGeometry(
                params?.radius || 1,
                Math.max(0, Math.floor((params?.detail || 0) - div)) // تقليل تفاصيل الـ Icosahedron بالخلع المباشر
            );

        default:
            return new THREE.BoxGeometry(1, 1, 1);
    }
};

export const Geometry=({type="box",radiusTop=0.5,radiusBottom=0.5,...props}:GeometryProps):{mesh:THREE.Mesh,helper:THREE.Mesh}=>{

    let mesh:THREE.Mesh= new THREE.Mesh();
    let helper:THREE.Mesh= new THREE.Mesh();


    let params:ObjectType<any>={}
    
    if(props.parameters&&isValidJSON(props.parameters)){
        params=JSON.parse(props.parameters)
    }


    


    mesh.castShadow=true;
    const GeometriesLevel0: Record<GeometryTypes, THREE.BufferGeometry> = {
        "box":         createGeometryForLevel("box", params, 1),
        "cone":        createGeometryForLevel("cone", params, 1),
        "cylinder":    createGeometryForLevel("cylinder", params, 1),
        "sphere":      createGeometryForLevel("sphere", params, 1),
        "plane":       createGeometryForLevel("plane", params, 1),
        "torus":       createGeometryForLevel("torus", params, 1),
        "torusknot":   createGeometryForLevel("torusknot", params, 1),
        "circle":      createGeometryForLevel("circle", params, 1),
        "ring":        createGeometryForLevel("ring", params, 1),
        "icosahedron": createGeometryForLevel("icosahedron", params, 1)
    };

    // // 2. توليد كائنات الهندسة للمستوى 1 (تفاصيل متوسطة - بعد متوسط)
    // const GeometriesLevel1: Record<GeometryTypes, THREE.BufferGeometry> = {
    //     "box":         createGeometryForLevel("box", params, 1),
    //     "cone":        createGeometryForLevel("cone", params, 1),
    //     "cylinder":    createGeometryForLevel("cylinder", params, 1),
    //     "sphere":      createGeometryForLevel("sphere", params, 1),
    //     "plane":       createGeometryForLevel("plane", params, 1),
    //     "torus":       createGeometryForLevel("torus", params, 1),
    //     "torusknot":   createGeometryForLevel("torusknot", params, 1),
    //     "circle":      createGeometryForLevel("circle", params, 1),
    //     "ring":        createGeometryForLevel("ring", params, 1),
    //     "icosahedron": createGeometryForLevel("icosahedron", params, 1)
    // };

    // // 3. توليد كائنات الهندسة للمستوى 2 (تفاصيل منخفضة - بعيد جداً)
    // const GeometriesLevel2: Record<GeometryTypes, THREE.BufferGeometry> = {
    //     "box":         createGeometryForLevel("box", params, 2),
    //     "cone":        createGeometryForLevel("cone", params, 2),
    //     "cylinder":    createGeometryForLevel("cylinder", params, 2),
    //     "sphere":      createGeometryForLevel("sphere", params, 2),
    //     "plane":       createGeometryForLevel("plane", params, 2),
    //     "torus":       createGeometryForLevel("torus", params, 2),
    //     "torusknot":   createGeometryForLevel("torusknot", params, 2),
    //     "circle":      createGeometryForLevel("circle", params, 2),
    //     "ring":        createGeometryForLevel("ring", params, 2),
    //     "icosahedron": createGeometryForLevel("icosahedron", params, 2)
    // };



    mesh.geometry=GeometriesLevel0[type];

    
    mesh.material= new THREE.MeshPhysicalMaterial({
        ...props.material,
        color: new THREE.Color(...hexToRGB(props.material?.color||"#eeeeee")),
        transparent:true,
        side: THREE.DoubleSide,
    
    });



    let texture:THREE.Texture|null=null;
    if(props.material?.imageUrl){
        const textureLoader= new THREE.TextureLoader();                        
        texture =textureLoader.load(process.env.REACT_APP_API_URL+routes?.api.images+"/"+props.material?.imageUrl);
        (mesh.material as THREE.MeshPhysicalMaterial).map= texture
    }




    if(props.position){
        mesh.position.set(props.position[0],props.position[1],props.position[2])
        mesh.updateMatrix();
    }

    if(props.scale){
        mesh.scale.set(props.scale[0],props.scale[1],props.scale[2])
        mesh.updateMatrix();
    }

    if(props.rotation){
        mesh.rotation.set(props.rotation[0],props.rotation[1],props.rotation[2])
        mesh.updateMatrix();
    }







    mesh.userData={
        ...mesh.userData,
        type,
        params,
        original:GeometriesLevel0[type]
    }
    

    // clone the Mesh For Create a Helper Mesh
    helper=mesh.clone(); 
    // set standert Material props 
    helper.material= new THREE.MeshStandardMaterial({color:"#fff",emissive:"#f00",transparent:true,opacity:0.4});
    // scaler of the Helper mesh  +0.1m
    helper.scale.set(Number(mesh.scale.x)+0.1,Number(mesh.scale.y)+0.1,Number(mesh.scale.z)+0.1);
    helper.updateMatrix();


    return {mesh,helper};

}